"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userSubscriptionToUserFacingWeeklyCoachingSubscription = void 0;
const types_1 = require("@fluent-forever/types");
const userSubscriptionToUserFacingWeeklyCoachingSubscription = ({ id, planId, nextBillingAt, status, expiresAt, metadata, nextBillingAmount, }) => {
    if (!types_1.isWeeklyCoachingSubscriptionMetadata(metadata)) {
        throw new Error(`Invalid metadata in Weekly Coaching subscription [${id}]`);
    }
    return {
        expiresAt,
        id,
        langPairCode: metadata.langPairCode,
        nextBillingAmount,
        nextBillingAt,
        planId,
        status,
    };
};
exports.userSubscriptionToUserFacingWeeklyCoachingSubscription = userSubscriptionToUserFacingWeeklyCoachingSubscription;
//# sourceMappingURL=weekly_coaching_adapters.js.map